export default __webpack_public_path__ + "static/media/Blue Jays.483b9246.png";